import React, { useContext } from "react";
import Table from "../../shared/Table";

const LastMeasuredQmsTable = ({task}) => {

  const QmChildren = ({task}) => {

    // showMultipleQms returns true if we should show more than one QM. Kidney function tests are usually paired (e.g. EGFR and Urine Protein Screening)
    let showMultipleQms = task.cpr.procedure_type == 'Kidney Function Test' && task.cpr.last_measured_quality_measurements.length > 1;

    return (
      <>
      <tr>
        <td>{task.cpr.last_measured_quality_measurements.at(-1).name}</td>
        <td>{task.cpr.last_measured_quality_measurements.at(-1).measured_at_date}</td>
        <td>
          {task.cpr.last_measured_quality_measurements.at(-1).attending_provider}
        </td>
      </tr>

      { showMultipleQms && (
          <>
            <tr>
              <td>{task.cpr.last_measured_quality_measurements.at(-2).name}</td>
              <td>{task.cpr.last_measured_quality_measurements.at(-2).measured_at_date}</td>
              <td>
                {task.cpr.last_measured_quality_measurements.at(-2).attending_provider}
              </td>
            </tr>
          </>
      ) }
      </>
    );

  };
  return (
    <Table
      headers={["Procedure Type", "Measurement Date", "Attending Provider"].map((i) => (
        <th key={i}>{i}</th>
      ))}
      children={
        <QmChildren task={task} />
      }
    />
  );

}

export default LastMeasuredQmsTable;
